import React from "react";
import { Banner, Button, Card, SkeletonBodyText } from "@shopify/polaris";
import { isSupportAccessDenied } from "../../util/supportAccess";

const WorkspaceState = ({ loading, error, hasData, refreshing, onRetry, children }) => {
  if (loading && !hasData) {
    return (
      <Card>
        <div className="store-support-card" aria-label="Loading store workspace">
          <SkeletonBodyText lines={10} />
        </div>
      </Card>
    );
  }

  if (error && !hasData) {
    const accessDenied = isSupportAccessDenied(error);
    return (
      <Banner
        title={accessDenied ? "Support access is required" : "Store workspace is unavailable"}
        status="critical"
        action={{ content: "Retry", onAction: onRetry }}
      >
        <p>{error}</p>
      </Banner>
    );
  }

  return (
    <>
      {error ? (
        <Banner
          title={isSupportAccessDenied(error) ? "Support access is required" : "The latest store refresh failed"}
          status={isSupportAccessDenied(error) ? "critical" : "warning"}
        >
          <p>{error}. Showing the last successful snapshot.</p>
        </Banner>
      ) : null}
      {children}
      <div className="store-support-refresh">
        <Button onClick={onRetry} loading={refreshing}>Refresh store snapshot</Button>
      </div>
    </>
  );
};

export default WorkspaceState;
